module.exports = __webpack_public_path__ + "static/media/nzcardholder.e3fedfae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/nzcardholder.png
// module id = 350
// module chunks = 1